import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/icons/logo.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Navbar() {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang);
  };

  const handleNavClick = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/");

      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  return (
    <header>
      <ul>
        <button onClick={toggleLanguage} class="langaugeBtn">
          {i18n.language === "en" ? "AR" : "EN"}
        </button>
        <button
          className="investBtn"
          onClick={() => navigate("/investmentRequest")}
        >
          {t("request_invest")}
        </button>
        <div className="nav-links">
          <a onClick={() => handleNavClick("home")}>{t("home")}</a>
          <a onClick={() => handleNavClick("investments")}>
            {t("investments")}
          </a>
          <a onClick={() => handleNavClick("qualifications")}>
            {t("qualifications")}
          </a>
          <a onClick={() => handleNavClick("achievements")}>
            {t("achievements")}
          </a>
          <a onClick={() => handleNavClick("resume")}>{t("resume")}</a>
          <a onClick={() => navigate("/gallery")}>{t("gallery")}</a>
        </div>
        <a href="/">
        <img className="logo" src={logo} alt="Logo" />
     </a>
      </ul>
    </header>
  );
}
